import { USER_KEY } from '../constants'

export default () => {
  const { attendantId } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return attendantId;
}
